import { Stack, H1, Text, FlexContainer } from "@carrotfertility/carotene"
import React from "react"
import { ThemeProvider } from "styled-components"
import { fleFormTheme } from "themes/formThemes"
import { useBodyClass } from "utils/Hooks"
import { ButtonPrimary } from "../atoms/buttons/ButtonPrimary"
import { IlloUnderwaterDashboard } from "../atoms/Illustrations"
import { FleLayout } from "./FleLayout"

export function FleComplete(): JSX.Element {
  useBodyClass("bg-warm-gray")

  return (
    <ThemeProvider theme={fleFormTheme}>
      <FleLayout>
        <Stack alignItems="center" spacing="medium" direction="column">
          <IlloUnderwaterDashboard />
          <Stack alignItems="center" direction="column" spacing="tiny">
            <H1>Thanks.</H1>
            <Text>{`We're so glad you're here.`}</Text>
          </Stack>
        </Stack>
        <FlexContainer stack="medium" paddingTopBottom="medium" justifyContent="center">
          <ButtonPrimary to="/">Go to Carrot home</ButtonPrimary>
        </FlexContainer>
      </FleLayout>
    </ThemeProvider>
  )
}
